import React from "react";
import useViewPortWidth from "../../hooks/useViewportWidth";
import ProductModal from "./productModal";
import ProductModalMobile from "./MobileView/productModalMobile";

const ProductModalHome = (props) => {
  const viewportWidth = useViewPortWidth();

  return (
    <>
      {
        viewportWidth > 500 ?
          <ProductModal
            show={props.show}
            handleClose={props.handleClose}
            product={props.product}
          />
          :
          <ProductModalMobile
            show={props.show}
            handleClose={props.handleClose}
            product={props.product}
          />
      }
    </>
  );

}

export default ProductModalHome;